import React, {useEffect, useState} from 'react';
import {Table as TableData} from 'antd';
import qs from 'qs';
import api from '../../config/axiosConfig';
import cx from 'classnames';
import {useMenu} from "../../context/context";
import './Table.module.scss';


const Table = ({
                   columns,
                   url,
                   rowIsUpdated,
                   dataSource,
                   expandedRowRender,
                   rowKey,
                   expandable,
                   onRow,
                   rowSelection,
                   onChange,
                   tableFilters,
                   setTableFilters,
                   onDataLoaded,
               }) => {
    const {menuIsCollapsed} = useMenu();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    useEffect(() => {
        if (dataSource) {
            setData(dataSource);
            // onDataLoaded && onDataLoaded(dataSource);
        } else if (url) {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const query = qs.stringify({
                        page: tableParams.pagination.current,
                        pageSize: tableParams.pagination.pageSize,
                        sortField: tableParams.sortField,
                        sortOrder: tableParams.sortOrder,
                        ...tableParams.filters, // Include filters in the query if server-side filtering
                    });
                    const response = await api.get(`${url}?${query}`);
                    setData(response.data);
                    onDataLoaded && onDataLoaded(response.data);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    }, [url, rowIsUpdated, dataSource]);

    useEffect(() => {
        if (Object.keys(tableFilters || {})?.length === 0) {
            onDataLoaded && onDataLoaded(data)
        }
    }, [tableFilters]);

    const handleTableChange = (pagination, filters, sorter, extra) => {
        setTableFilters && setTableFilters(filters);
        setTableParams((prevParams) => ({
            ...prevParams,
            pagination,
            filters,
            sortField: sorter.field,
            sortOrder: sorter.order,
        }));
        if (!dataSource) {
            onDataLoaded && onDataLoaded(extra.currentDataSource);
        } else {
            onDataLoaded && onDataLoaded(dataSource);
        }
    };

    return (
        <TableData
            columns={columns}
            rowKey={rowKey}
            dataSource={data}
            // pagination={tableParams.pagination}
            loading={loading}
            onChange={handleTableChange}
            pagination={{
                position: ['bottomCenter'],
                total: dataSource?.length,
                showTotal: (total, range) => `${total} ჩანაწერი`,
                onChange: (page, pageSize) => {window.scrollTo({ top: 0, behavior: 'instant' })
                },
            }}
            className={cx('table', {['menuIsCollapsed']: menuIsCollapsed})}
            expandable={expandable}
            onRow={onRow}
            bordered={true}
            rowSelection={rowSelection}
            // size={'middle'}
        />
    );
};
export default Table;